import React from "react";
import UpdatedHeader from "../components/layout/UpdatedHeader";
import UpdatedFooter from "../components/layout/UpdatedFooter";

const OLakeLayout = ({ children }) => (
  <>
    <UpdatedHeader navPosition="right" className="olake-layout-container" />
    <main className="site-content updated-site-content">{children}</main>
    <UpdatedFooter />
  </>
);

export default OLakeLayout;
